import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GearComponent } from './pages/gear/gear.component';
import { HeaderComponent } from './component/header/header.component';
import { JewelsComponent } from './pages/jewels/jewels.component';
import { OneHandedWeaponPiercingComponent } from './pages/one-handed-weapon-piercing/one-handed-weapon-piercing.component';
import { TwoHandedWeaponPiercingComponent } from './pages/two-handed-weapon-piercing/two-handed-weapon-piercing.component';
import { SuitPiercingComponent } from './pages/suit-piercing/suit-piercing.component';
import { FooterComponent } from './component/footer/footer.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { PriceProviderService } from './services/price-provider.service';
import { DailyCalculatorComponent } from './pages/daily-calculator/daily-calculator.component';
import { UltiWeaponComponent } from './pages/ulti-weapon/ulti-weapon.component';
import { UltiJewelsComponent } from './pages/ulti-jewels/ulti-jewels.component';

@NgModule({
  declarations: [
    AppComponent,
    GearComponent,
    HeaderComponent,
    UltiWeaponComponent,
    UltiJewelsComponent,
    OneHandedWeaponPiercingComponent,
    TwoHandedWeaponPiercingComponent,
    SuitPiercingComponent,
    JewelsComponent,
    FooterComponent,
    DailyCalculatorComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatSlideToggleModule,
    NgxGoogleAnalyticsModule.forRoot("G-W7PY3PXVZZ"),
    NgxGoogleAnalyticsRouterModule,
  ],
  providers: [PriceProviderService],
  bootstrap: [AppComponent],
  exports: [RouterModule]
})
export class AppModule { }
